var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Aside',{staticClass:"asideVideo",attrs:{"ativo":_vm.content !== null},on:{"close":function($event){_vm.content = null}}},[_c('video',{attrs:{"src":_vm.content,"autoplay":"","controls":"","preload":"metadata"}})])}
var staticRenderFns = []

export { render, staticRenderFns }